(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3389],{

/***/ 92039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 3.75a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 3.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 8.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 13.75Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDotsVertical);

/***/ }),

/***/ 22764:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/finances/settings",
      function () {
        return __webpack_require__(55266);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HeaderNavigation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95571);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






const HeaderNavigation = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_navigation), props.sticky && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().menu),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inner),
                children: props.menu.map((it, key)=>{
                    const active = it.exact ? router.asPath === it.href : router.asPath.startsWith(it.href);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: it.href,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                        children: it.label
                    }, it.href);
                })
            })
        })
    });
};
HeaderNavigation.defaultProps = {};


/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83083);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10078);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const Sidebar = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const { groups , menu  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const propsMenu = props.menu.filter((it)=>it);
        if (!propsMenu.length) return {
            groups: null,
            menu: []
        };
        if ("menu" in propsMenu[0]) {
            const groups = propsMenu.map((it)=>({
                    ...it,
                    menu: it.menu.filter((it)=>it)
                }));
            const menu = groups.map((it)=>it.menu).flat();
            return {
                groups,
                menu
            };
        } else {
            return {
                groups: null,
                menu: propsMenu
            };
        }
    }, [
        props.menu
    ]);
    const checkActiveForDescktop = (menuItem)=>{
        if (router.asPath.startsWith(menuItem.additionalHref)) return true;
        switch(router.asPath){
            case menuItem.href:
                return true;
            case menuItem.additionalHref:
                return true;
            default:
                if (!menuItem.exact) return router.asPath.startsWith(menuItem.href);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const activeLink = menu.find((elem)=>{
            if (elem.exact) return router.asPath === elem.additionalHref;
            return router.asPath.startsWith(elem.href);
        });
        setActiveMenu(activeLink);
    }, [
        menu,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar), props.sticky && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar_adaptive),
                children: activeMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: props.mainHref,
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        activeMenu.label,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().spacer)
                        })
                    ]
                }) : menu.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().adaptive_item),
                        href: it.exact ? it.additionalHref : it.href,
                        children: it.label
                    }, it.href))
            }),
            groups === null || groups === void 0 ? void 0 : groups.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [
                        it.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().group_title),
                            children: it.title
                        }),
                        it.menu.map((it)=>{
                            const active = checkActiveForDescktop(it);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: it.href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: it.label
                            }, it.href);
                        })
                    ]
                }, key)),
            !groups && menu.map((it)=>{
                const active = checkActiveForDescktop(it);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: it.href,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                    children: it.label
                }, it.href);
            })
        ]
    });
};
Sidebar.defaultProps = {
    sticky: true
};


/***/ }),

/***/ 47656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WithSidebarContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57711);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11682);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const WithSidebarContainer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const hideOnMobile = router.asPath === props.mainHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
        fullWidth: props.fullWidth,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().with_sidebar_container), props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar),
                children: props.sidebar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), hideOnMobile && (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide_on_mobile)),
                children: props.children
            })
        ]
    });
};
WithSidebarContainer.defaultProps = {};


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMyPermissions; }
/* harmony export */ });
/* unused harmony export convertPermissions */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22823);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94840);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);


const convertPermissions = (roleType, permissions)=>{
    const set = new Set(permissions);
    const isOwner = roleType === shared_api__WEBPACK_IMPORTED_MODULE_1__/* .CompanyEmployeeRoleType.OWNER */ .Or.OWNER;
    return {
        finances: {
            budgets: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            plannings: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            fundingRequests: {
                create: true,
                readAll: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_READ_ALL */ .Mn.CLAIM_READ_ALL),
                acceptOrDecline: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */ .Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE),
                close: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE) || set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF),
                pay: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF)
            },
            funds: {
                withdraw: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_WITHDRAW */ .Mn.FUND_WITHDRAW),
                deposit: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_DEPOSIT */ .Mn.FUND_DEPOSIT),
                readProtected: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_SECURED_READ */ .Mn.FUND_SECURED_READ)
            }
        },
        company: {
            general: {
                update: isOwner,
                delete: isOwner
            },
            members: {
                invite: isOwner,
                update: isOwner,
                remove: isOwner
            },
            roles: {
                write: isOwner
            }
        }
    };
};
const useMyPermissions = (companySlug)=>{
    var _me_data;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const role = (_me_data = me.data) === null || _me_data === void 0 ? void 0 : _me_data.companyEmployeeRole;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!role ? null : convertPermissions(role.type, role.permissions), [
        role
    ]);
};


/***/ }),

/***/ 59906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ CompanyLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/auth/model/auth-guard.model.tsx
var auth_guard_model = __webpack_require__(95244);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/company/entities/company/company-expired/company-expired.module.scss
var company_expired_module = __webpack_require__(60978);
var company_expired_module_default = /*#__PURE__*/__webpack_require__.n(company_expired_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/company/company-expired/company-expired.tsx




const CompanyExpired = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((company_expired_module_default()).company_expired, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_expired_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Для этой компании закончился период доступа"
            })
        })
    });
};
CompanyExpired.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx + 13 modules
var header_dashboard = __webpack_require__(35622);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-navigation/header-navigation.tsx
var header_navigation = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-title/header-title.tsx
var header_title = __webpack_require__(35629);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/pages/[company]/_layout.tsx








const CompanyLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(companySlug);
    (0,auth_guard_model/* useGuardAuthedOnly */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_dashboard/* HeaderDashboard */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_navigation/* HeaderNavigation */.F, {
                menu: [
                    {
                        label: "Финансы",
                        href: _router/* default.company */.Z.company(companySlug).finances.href
                    },
                    // { label: "Департаменты", href: pages.company(companySlug).departments.href },
                    {
                        label: "Настройки",
                        href: _router/* default.company */.Z.company(companySlug).settings.href
                    }
                ],
                sticky: props.stickyNavigation
            }),
            company.data && !company.data.hasAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyExpired, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_title/* HeaderTitle */.G, {
                        fullWidth: true,
                        back: props.back,
                        actions: props.actions,
                        children: props.title
                    }),
                    props.children
                ]
            })
        ]
    });
};
CompanyLayout.defaultProps = {
    stickyNavigation: true
};


/***/ }),

/***/ 89220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ CompanyFinancesLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/modules/finances/_shared/model/has-deferred-incomes.ts

const useHasDeferredIncomes = (companySlugOrId)=>{
    var _deferredIncomeExists_data;
    const deferredIncomeExists = init/* api.deferredIncome.useDeferredIncomeExists */.h.deferredIncome.useDeferredIncomeExists(companySlugOrId);
    return (_deferredIncomeExists_data = deferredIncomeExists.data) === null || _deferredIncomeExists_data === void 0 ? void 0 : _deferredIncomeExists_data._exists;
};

// EXTERNAL MODULE: ./src/modules/layout/ui/with-sidebar-container/with-sidebar-container.tsx
var with_sidebar_container = __webpack_require__(47656);
// EXTERNAL MODULE: ./src/modules/layout/ui/sidebar/sidebar.tsx
var sidebar = __webpack_require__(6480);
// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/[company]/_layout.tsx + 1 modules
var _layout = __webpack_require__(59906);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/_layout.tsx








const CompanyFinancesLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(companySlug);
    const hasDeferred = useHasDeferredIncomes(companySlug);
    const mainHref = _router/* default.company */.Z.company(companySlug).finances.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_layout/* CompanyLayout */.q, {
        title: "Финансы",
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(with_sidebar_container/* WithSidebarContainer */.I, {
            mainHref: mainHref,
            fullWidth: props.fullWidth,
            sidebar: /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar/* Sidebar */.Y, {
                mainHref: mainHref,
                menu: [
                    {
                        menu: [
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Месячные бюджеты",
                                href: _router/* default.company */.Z.company(companySlug).finances.href,
                                exact: true,
                                additionalHref: _router/* default.company */.Z.company(companySlug).finances.plan.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Заявки на расход",
                                href: _router/* default.company */.Z.company(companySlug).finances.fundingRequests.href
                            },
                            !(permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Заявки на расход",
                                href: _router/* default.company */.Z.company(companySlug).finances.href,
                                exact: true,
                                additionalHref: _router/* default.company */.Z.company(companySlug).finances.fundingRequests.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Фонды и счета",
                                href: _router/* default.company */.Z.company(companySlug).finances.funds.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Движение средств",
                                href: _router/* default.company */.Z.company(companySlug).finances.reports.cashFlow.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.fundingRequests.pay) && {
                                label: "Выплаты",
                                href: _router/* default.company */.Z.company(companySlug).finances.payouts.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Займы",
                                href: _router/* default.company */.Z.company(companySlug).finances.loans.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && hasDeferred && {
                                label: "Отложенный доход",
                                href: _router/* default.company */.Z.company(companySlug).finances.deferredIncomes.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Обучение",
                                href: _router/* default.company */.Z.company(companySlug).finances.education.tableOfContent.href
                            },
                            {
                                label: "Настройки",
                                href: _router/* default.company */.Z.company(companySlug).finances.settings.href
                            }
                        ]
                    }
                ]
            }, companySlug),
            children: props.children
        })
    });
};


/***/ }),

/***/ 55266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ settings_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/lib/use-api-method.ts
var use_api_method = __webpack_require__(24453);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/fieldset.tsx + 8 modules
var fieldset = __webpack_require__(73053);
// EXTERNAL MODULE: ./src/shared/ui/select/select.tsx
var select_select = __webpack_require__(14080);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/modules/company/features/company-update/financial-day/company-update-financial-day-form.tsx





const CompanyFinancialDayForm = (props)=>{
    var _financeSettings_data;
    const financeSettings = init/* api.financeSettings.useFinanceSettingsGet */.h.financeSettings.useFinanceSettingsGet(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.financeSettings.financeSettingsUpdate */.h.financeSettings.financeSettingsUpdate);
    const [value, setValue] = (0,react.useState)();
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!financeSettings.data || !value) return;
        await submit.call(props.companySlug, {
            financialPlanningWeekDay: value
        });
        await financeSettings.mutate();
        setValue(undefined);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                            children: "День финансового планирования"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                            children: "Установите день, в который каждую неделю будет проводиться финансовое планирование. Этот день нельзя пропускать."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                            style: {
                                maxWidth: 200
                            },
                            value: value !== null && value !== void 0 ? value : (_financeSettings_data = financeSettings.data) === null || _financeSettings_data === void 0 ? void 0 : _financeSettings_data.financialPlanningWeekDay,
                            onChange: setValue,
                            options: [
                                {
                                    value: 1,
                                    label: "Понедельник"
                                },
                                {
                                    value: 2,
                                    label: "Вторник"
                                },
                                {
                                    value: 3,
                                    label: "Среда"
                                },
                                {
                                    value: 4,
                                    label: "Четверг"
                                },
                                {
                                    value: 5,
                                    label: "Пятница"
                                },
                                {
                                    value: 6,
                                    label: "Суббота"
                                },
                                {
                                    value: 7,
                                    label: "Воскресенье"
                                }
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {
                            children: [
                                !submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Рекомендуется Четверг, но вы можете установить любой день"
                                }),
                                submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Error */.p.Error, {
                                    children: submit.error.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                size: "small",
                                disabled: !value,
                                loading: submit.loading,
                                children: "Сохранить"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanyFinancialDayForm.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/input/input.tsx
var input = __webpack_require__(99088);
// EXTERNAL MODULE: ./src/shared/ui/error/error.tsx
var error = __webpack_require__(64871);
// EXTERNAL MODULE: ./src/shared/ui/loading-dots/loading-dots.tsx
var loading_dots = __webpack_require__(42966);
;// CONCATENATED MODULE: ./src/modules/finances/features/deposit-type-create-modal/deposit-type-create-modal.tsx





const DepositTypeCreateModal = (props)=>{
    const depositTypeList = init/* api.depositType.useDepositTypeList */.h.depositType.useDepositTypeList(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.depositType.depositTypeCreate */.h.depositType.depositTypeCreate);
    const [name, setName] = (0,react.useState)("");
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!name) return;
        await submit.call(props.companySlug, {
            name
        });
        await depositTypeList.mutate();
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Новый источник внедоходных поступлений"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: true,
                            placeholder: "Название",
                            value: name,
                            onChange: (e)=>setName(e.target.value)
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Создать" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Создаем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
DepositTypeCreateModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
;// CONCATENATED MODULE: ./src/modules/finances/features/deposit-type-delete-modal/deposit-type-delete-modal.tsx





const DepositTypeDeleteModal = (props)=>{
    const depositTypeList = init/* api.depositType.useDepositTypeList */.h.depositType.useDepositTypeList(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.depositType.depositTypeArchive */.h.depositType.depositTypeArchive);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data.id);
        await depositTypeList.mutate();
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удалить источник внедоходных поступлений"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity */.J, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: props.data.name
                            })
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаляем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
DepositTypeDeleteModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
// EXTERNAL MODULE: ./src/shared/ui/table/table.tsx + 4 modules
var table = __webpack_require__(5663);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/container/menu-container.tsx
var menu_container = __webpack_require__(8581);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/button/menu-button.tsx
var menu_button = __webpack_require__(92422);
// EXTERNAL MODULE: ./src/shared/ui/icon/dots-vertical.svg
var dots_vertical = __webpack_require__(92039);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/menu/menu.tsx
var menu = __webpack_require__(78024);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/item/menu-item.tsx
var menu_item = __webpack_require__(38234);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/deposit-types-form/deposit-types-form.tsx






const DepositTypesForm = (props)=>{
    var _depositTypeList_data;
    const depositTypeList = init/* api.depositType.useDepositTypeList */.h.depositType.useDepositTypeList(props.companySlug);
    const onCreate = ()=>{
        use_modal/* Modals.open */.nK.open(DepositTypeCreateModal, {
            companySlug: props.companySlug
        });
    };
    const onDelete = (data)=>{
        use_modal/* Modals.open */.nK.open(DepositTypeDeleteModal, {
            data,
            companySlug: props.companySlug
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                        children: "Внедоходные источники средств"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                        children: "При зачислении денег напрямую в фонд нужно указать, откуда пришли деньги. В этой секции укажите список всех возможных источников внедоходных поступлений."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* Table */.i, {
                        type: "plain",
                        columns: [
                            {
                                header: "",
                                accessor: "name"
                            },
                            {
                                header: "",
                                accessor: "actions",
                                align: "right"
                            }
                        ],
                        data: (_depositTypeList_data = depositTypeList.data) === null || _depositTypeList_data === void 0 ? void 0 : _depositTypeList_data.map((it)=>({
                                id: it.id,
                                name: it.name,
                                actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                                            svgOnly: true,
                                            size: "small",
                                            variant: "ghost",
                                            style: {
                                                marginLeft: "auto"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                                            minWidth: 150,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                                                type: "error",
                                                onClick: ()=>onDelete(it),
                                                children: "Удалить"
                                            })
                                        })
                                    ]
                                })
                            })),
                        header: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            size: "small",
                            onClick: onCreate,
                            children: "Добавить"
                        })
                    })
                ]
            })
        ]
    });
};
DepositTypesForm.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/finances/features/income-type-create/income-type-create-modal.tsx





const IncomeTypeCreateModal = (props)=>{
    const incomeTypeList = init/* api.incomeType.useIncomeTypeList */.h.incomeType.useIncomeTypeList(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.incomeType.incomeTypeCreate */.h.incomeType.incomeTypeCreate);
    const [name, setName] = (0,react.useState)("");
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!name) return;
        await submit.call(props.companySlug, {
            name
        });
        await incomeTypeList.mutate();
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Новый тип дохода"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: true,
                            placeholder: "Название",
                            value: name,
                            onChange: (e)=>setName(e.target.value),
                            required: true
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Создать" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Создаем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
IncomeTypeCreateModal.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/finances/features/income-type-update/income-type-update-modal.tsx





const IncomeTypeUpdateModal = (props)=>{
    const incomeTypeList = init/* api.incomeType.useIncomeTypeList */.h.incomeType.useIncomeTypeList(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.incomeType.incomeTypeRename */.h.incomeType.incomeTypeRename);
    const [name, setName] = (0,react.useState)(props.data.name);
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!name || !name.trim()) return;
        await submit.call(props.companySlug, props.data.id, {
            name
        });
        await incomeTypeList.mutate();
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Редактировать тип дохода"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: true,
                            placeholder: "Название",
                            value: name,
                            onChange: (e)=>setName(e.target.value),
                            required: true
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Сохранить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Сохраняем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
IncomeTypeUpdateModal.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/finances/features/income-type-delete/income-type-delete-modal.tsx





const IncomeTypeDeleteModal = (props)=>{
    const incomeTypeList = init/* api.incomeType.useIncomeTypeList */.h.incomeType.useIncomeTypeList(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.incomeType.incomeTypeArchive */.h.incomeType.incomeTypeArchive);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data.id);
        await incomeTypeList.mutate();
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 400,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удалить тип дохода"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity */.J, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: props.data.name
                            })
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Назад"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаляем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
IncomeTypeDeleteModal.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/finances/widgets/income-type-list/income-type-list.tsx






const IncomeTypeList = (props)=>{
    var _incomeTypeList_data;
    const incomeTypeList = init/* api.incomeType.useIncomeTypeList */.h.incomeType.useIncomeTypeList(props.companySlug);
    const onCreate = ()=>{
        use_modal/* Modals.open */.nK.open(IncomeTypeCreateModal, {
            companySlug: props.companySlug
        });
    };
    const onUpdate = (data)=>{
        use_modal/* Modals.open */.nK.open(IncomeTypeUpdateModal, {
            data,
            companySlug: props.companySlug
        });
    };
    const onDelete = (data)=>{
        use_modal/* Modals.open */.nK.open(IncomeTypeDeleteModal, {
            data,
            companySlug: props.companySlug
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                        children: "Типы доходов"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                        children: "Типы доходов используются в\xa0планах на\xa0месяц. Лишние типы доходов можно удалять. Если удалить тип дохода, он\xa0не\xa0исчезнет из\xa0текущих планов на\xa0месяц."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* Table */.i, {
                        type: "plain",
                        columns: [
                            {
                                header: "",
                                accessor: "name"
                            },
                            {
                                header: "",
                                accessor: "actions",
                                align: "right"
                            }
                        ],
                        data: (_incomeTypeList_data = incomeTypeList.data) === null || _incomeTypeList_data === void 0 ? void 0 : _incomeTypeList_data.map((it)=>({
                                id: it.id,
                                name: it.name,
                                actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                                            svgOnly: true,
                                            size: "small",
                                            variant: "ghost",
                                            style: {
                                                marginLeft: "auto"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
                                            minWidth: 150,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                                                    onClick: ()=>onUpdate(it),
                                                    children: "Редактировать"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                                                    type: "error",
                                                    onClick: ()=>onDelete(it),
                                                    children: "Удалить"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })),
                        header: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            size: "small",
                            onClick: onCreate,
                            children: "Добавить"
                        })
                    })
                ]
            })
        ]
    });
};
IncomeTypeList.defaultProps = {};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/[company]/finances/_layout.tsx + 1 modules
var _layout = __webpack_require__(89220);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/settings.page.tsx






const FinancesSettingsPage = ()=>{
    const companySlug = (0,router.useRouter)().query.company;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanyFinancesLayout */.G, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFinancialDayForm, {
                companySlug: companySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositTypesForm, {
                companySlug: companySlug,
                htmlId: "deposit-types"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IncomeTypeList, {
                companySlug: companySlug
            })
        ]
    });
};
/* harmony default export */ var settings_page = (FinancesSettingsPage);


/***/ }),

/***/ 51978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Entity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/ui/entity/entity-menu-context.tsx

const EntityMenuContext = /*#__PURE__*/ react.createContext(null);

// EXTERNAL MODULE: ./src/shared/ui/icon/dots-vertical.svg
var dots_vertical = __webpack_require__(92039);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/container/menu-container.tsx
var menu_container = __webpack_require__(8581);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/button/menu-button.tsx
var menu_button = __webpack_require__(92422);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/menu/menu.tsx
var menu = __webpack_require__(78024);
// EXTERNAL MODULE: ./src/shared/ui/entity/actions/entity-actions.module.scss
var entity_actions_module = __webpack_require__(3115);
var entity_actions_module_default = /*#__PURE__*/__webpack_require__.n(entity_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/actions/entity-actions.tsx







const EntityActions = (props)=>{
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_actions_module_default()).entity_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.children,
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_actions_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityActions.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.module.scss
var entity_module = __webpack_require__(68404);
var entity_module_default = /*#__PURE__*/__webpack_require__.n(entity_module);
// EXTERNAL MODULE: ./src/shared/ui/entity/field/entity-field.module.scss
var entity_field_module = __webpack_require__(38244);
var entity_field_module_default = /*#__PURE__*/__webpack_require__.n(entity_field_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/field/entity-field.tsx







const EntityField = (props)=>{
    const style = (0,react.useMemo)(()=>{
        const width = typeof props.width === "number" ? props.width + "px" : props.width;
        if (!width) {
            return props.style;
        } else {
            return {
                ...props.style,
                flex: "0 0 ".concat(width)
            };
        }
    }, [
        props.style,
        props.width
    ]);
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_field_module_default()).entity_field, props.flex && (entity_field_module_default()).flex, props.right && (entity_field_module_default()).right, props.label && (entity_field_module_default()).label, props.className),
        style: style,
        id: props.htmlId,
        children: [
            props.avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: props.avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((entity_field_module_default()).content),
                id: props.htmlId,
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).title,
                        children: props.title
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).description,
                        children: props.description
                    }),
                    props.children
                ]
            }),
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_field_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityField.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/entity/entity.tsx







const Entity = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_module_default()).entity, props.hover && (entity_module_default()).hover, "entity", props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityMenuContext.Provider, {
                value: props.menuItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (entity_module_default()).content,
                    style: {
                        "--flex": 1
                    },
                    children: [
                        props.checkbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(Entity.Field, {
                            width: 16,
                            children: props.checkbox
                        }),
                        props.children
                    ]
                })
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_module_default()).footer,
                children: props.footer
            })
        ]
    });
};
Entity.Field = EntityField;
Entity.Actions = EntityActions;
Entity.defaultProps = {};


/***/ }),

/***/ 73053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ Fieldset; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/error/fieldset-error.module.scss
var fieldset_error_module = __webpack_require__(98919);
var fieldset_error_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_error_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/error/fieldset-error.tsx




const FieldsetError = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((fieldset_error_module_default()).fieldset_error, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetError.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/content/fieldset-content.module.scss
var fieldset_content_module = __webpack_require__(50170);
var fieldset_content_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_content_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/content/fieldset-content.tsx




const FieldsetContent = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_content_module_default()).fieldset_content, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetContent.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/fieldset.module.scss
var fieldset_module = __webpack_require__(55290);
var fieldset_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_module);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/fieldset-footer.module.scss
var fieldset_footer_module = __webpack_require__(4266);
var fieldset_footer_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_module);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/status/fieldset-footer-status.module.scss
var fieldset_footer_status_module = __webpack_require__(618);
var fieldset_footer_status_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_status_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/status/fieldset-footer-status.tsx




const FieldsetFooterStatus = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_status_module_default()).fieldset_footer_status, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooterStatus.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/actions/fieldset-footer-actions.module.scss
var fieldset_footer_actions_module = __webpack_require__(70148);
var fieldset_footer_actions_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/actions/fieldset-footer-actions.tsx




const FieldsetFooterActions = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_actions_module_default()).fieldset_footer_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooterActions.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/fieldset-footer.tsx






const FieldsetFooter = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_module_default()).fieldset_footer, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooter.Status = FieldsetFooterStatus;
FieldsetFooter.Actions = FieldsetFooterActions;
FieldsetFooter.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/header/fieldset-header.module.scss
var fieldset_header_module = __webpack_require__(16549);
var fieldset_header_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_header_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/header/fieldset-header.tsx




const FieldsetHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((fieldset_header_module_default()).fieldset_header, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fieldset_header_module_default()).title,
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fieldset_header_module_default()).actions,
                children: props.actions
            })
        ]
    });
};
FieldsetHeader.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/subtitle/fieldset-subtitle.module.scss
var fieldset_subtitle_module = __webpack_require__(24311);
var fieldset_subtitle_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_subtitle_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/subtitle/fieldset-subtitle.tsx




const FieldsetSubtitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_subtitle_module_default()).fieldset_subtitle, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetSubtitle.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/title/fieldset-title.module.scss
var fieldset_title_module = __webpack_require__(37125);
var fieldset_title_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_title_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/title/fieldset-title.tsx




const FieldsetTitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_title_module_default()).fieldset_title, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetTitle.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/fieldset/fieldset.tsx










const Fieldset = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_module_default()).fieldset, props.disabled && (fieldset_module_default()).disabled, props.type === "error" && (fieldset_module_default()).error, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
Fieldset.Header = FieldsetHeader;
Fieldset.Content = FieldsetContent;
Fieldset.Footer = FieldsetFooter;
Fieldset.Title = FieldsetTitle;
Fieldset.Subtitle = FieldsetSubtitle;
Fieldset.Error = FieldsetError;
Fieldset.defaultProps = {};


/***/ }),

/***/ 5663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tanstack/table-core/build/lib/index.mjs
var lib = __webpack_require__(27060);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-table/build/lib/index.mjs
var build_lib = __webpack_require__(74094);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/lib/use-handle-scroll.ts

function isElementScrollableRight(element) {
    if (element === null || element === void 0 ? void 0 : element.current) {
        var _element_current, _element_current1, _element_current2;
        return ((_element_current = element.current) === null || _element_current === void 0 ? void 0 : _element_current.scrollWidth) > ((_element_current1 = element.current) === null || _element_current1 === void 0 ? void 0 : _element_current1.clientWidth) + ((_element_current2 = element.current) === null || _element_current2 === void 0 ? void 0 : _element_current2.scrollLeft);
    }
    return false;
}
const useHandleScroll = ()=>{
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    const containerRef = (0,react.useRef)(null);
    function handleScroll() {
        var _containerRef_current;
        const position = ((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) || 0;
        setScrollPosition(position);
    }
    (0,react.useEffect)(()=>{
        const container = containerRef.current;
        container === null || container === void 0 ? void 0 : container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            container === null || container === void 0 ? void 0 : container.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        scrollRef: containerRef,
        scrollPosition
    };
};

// EXTERNAL MODULE: ./src/shared/ui/icon/down.svg
var down = __webpack_require__(83083);
// EXTERNAL MODULE: ./src/shared/ui/table/rows/table-rows.module.scss
var table_rows_module = __webpack_require__(97173);
var table_rows_module_default = /*#__PURE__*/__webpack_require__.n(table_rows_module);
;// CONCATENATED MODULE: ./src/shared/ui/table/rows/table-rows.tsx






const TableRows = (param)=>{
    let { row , expandableColumn , subRow , header  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    console.log(row);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                className: classnames_default()((table_rows_module_default()).row, row.original.className, row.original.isTotal && (table_rows_module_default()).total),
                children: row.getVisibleCells().map((cell, index)=>{
                    if (expandableColumn === cell.column.id && row.subRows.length > 0) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            onClick: ()=>setIsOpen(!isOpen),
                            className: classnames_default()((table_rows_module_default()).row_item, index == 0 && subRow && (table_rows_module_default()).sub_row, header[index].align === "left" && (table_rows_module_default()).left, header[index].align === "center" && (table_rows_module_default()).center, header[index].align === "right" && (table_rows_module_default()).right),
                            children: [
                                (0,build_lib/* flexRender */.ie)(cell.column.columnDef.cell, cell.getContext()),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(down/* default */.Z, {
                                    className: isOpen ? (table_rows_module_default()).row_active : ""
                                })
                            ]
                        }, cell.id);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: classnames_default()(index == 0 && subRow && (table_rows_module_default()).sub_row, header[index].align === "left" && (table_rows_module_default()).left, header[index].align === "center" && (table_rows_module_default()).center, header[index].align === "right" && (table_rows_module_default()).right),
                        children: (0,build_lib/* flexRender */.ie)(cell.column.columnDef.cell, cell.getContext())
                    }, cell.id);
                })
            }, row.id),
            isOpen && row.subRows.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableRows, {
                    header: header,
                    expandableColumn: expandableColumn,
                    row: row,
                    subRow: true
                }, row.id))
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/ui/table/body/table-body.tsx



const TableBody = (props)=>{
    const defaultArray = (0,react.useMemo)(()=>{
        return Array(props.defaultRows).fill(1).map((_, index)=>index);
    }, [
        props.defaultRows
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
        children: [
            props.table.getRowModel().rows.length === 0 && props.placeholder ? defaultArray.map((elem, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: props.table.getAllColumns().map((elem, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            children: " "
                        }, index))
                }, index)) : "",
            props.table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableRows, {
                    row: row,
                    header: props.header,
                    expandableColumn: props.expandableColumn
                }, row.id))
        ]
    });
};
TableBody.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/table/header/table-header.module.scss
var table_header_module = __webpack_require__(37586);
var table_header_module_default = /*#__PURE__*/__webpack_require__.n(table_header_module);
;// CONCATENATED MODULE: ./src/shared/ui/table/header/table-header.tsx





const TableHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
        children: props.table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                className: (table_header_module_default()).table_header,
                children: headerGroup.headers.map((header, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        className: classnames_default()((table_header_module_default()).header_column, props.columns[index].align === "left" && (table_header_module_default()).left, props.columns[index].align === "center" && (table_header_module_default()).center, props.columns[index].align === "right" && (table_header_module_default()).right),
                        style: {
                            width: "".concat(props.columns[index].fixedWidth ? props.columns[index].fixedWidth + "px" : "auto")
                        },
                        children: header.isPlaceholder ? null : (0,build_lib/* flexRender */.ie)(header.column.columnDef.header, header.getContext())
                    }, header.id))
            }, headerGroup.id))
    });
};
TableHeader.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/table/table.module.scss
var table_module = __webpack_require__(45882);
var table_module_default = /*#__PURE__*/__webpack_require__.n(table_module);
;// CONCATENATED MODULE: ./src/shared/ui/table/table.tsx








const Table = (props)=>{
    const columnHelper = (0,lib/* createColumnHelper */.Cl)();
    const { scrollRef , scrollPosition  } = useHandleScroll();
    const expandableColumn = (0,react.useMemo)(()=>{
        var _props_columns_find;
        return (_props_columns_find = props.columns.find((elem)=>elem.expandable)) === null || _props_columns_find === void 0 ? void 0 : _props_columns_find.accessor;
    }, [
        props.columns
    ]);
    const defaultColumn = (0,react.useMemo)(()=>props.columns.map((elem)=>// @ts-ignore
            columnHelper.accessor(elem.accessor, {
                id: elem.accessor,
                header: elem.header,
                cell: (props)=>props.getValue()
            })), [
        columnHelper,
        props.columns
    ]);
    const table = (0,build_lib/* useReactTable */.b7)({
        columns: defaultColumn,
        data: props.data || [],
        getCoreRowModel: (0,lib/* getCoreRowModel */.sC)(),
        getSubRows: (originalData)=>originalData.subRows
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((table_module_default()).table_wrapper, props.type === "plain" && (table_module_default()).plain, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((table_module_default()).scroller_overlay_container),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((table_module_default()).scroller_overlay, scrollPosition > 0 && (table_module_default()).left, isElementScrollableRight(scrollRef) && (table_module_default()).right)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((table_module_default()).table_scroller),
                    ref: scrollRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (table_module_default()).table_tableWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: (table_module_default()).table,
                                children: [
                                    props.header !== false && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader, {
                                        table: table,
                                        columns: props.columns
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                                        table: table,
                                        header: props.columns,
                                        expandableColumn: expandableColumn,
                                        placeholder: props.placeholder,
                                        defaultRows: props.defaultRows
                                    })
                                ]
                            })
                        }),
                        table.getRowModel().rows.length === 0 && !props.placeholder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (table_module_default()).table_empty,
                            style: {
                                height: "calc(".concat(props.defaultRows || 1, " * var(--geist-gap-double))")
                            },
                            children: props.empty || "Нет данных"
                        })
                    ]
                })
            ]
        })
    });
};
Table.defaultProps = {};


/***/ }),

/***/ 60978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_expired":"company-expired_company_expired__1K5vq","inner":"company-expired_inner__2NWWa"};

/***/ }),

/***/ 95571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_navigation":"header-navigation_header_navigation__k37R9","sticky":"header-navigation_sticky__awsUq","menu":"header-navigation_menu__cb9yS","inner":"header-navigation_inner__OtSJ_","item":"header-navigation_item__FmE4u","active":"header-navigation_active__1bau7"};

/***/ }),

/***/ 10078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__sYHpc","sticky":"sidebar_sticky__tqhuP","sidebar_adaptive":"sidebar_sidebar_adaptive__It1u0","adaptive_item":"sidebar_adaptive_item__UCFjh","title":"sidebar_title__41UVT","item":"sidebar_item__3MhXw","active":"sidebar_active__ezSut","group_title":"sidebar_group_title__gZU9o","spacer":"sidebar_spacer__WlMwR"};

/***/ }),

/***/ 11682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_sidebar_container":"with-sidebar-container_with_sidebar_container__nlbUn","sidebar":"with-sidebar-container_sidebar__s3m9i","main":"with-sidebar-container_main__UyQ8Z","hide_on_mobile":"with-sidebar-container_hide_on_mobile__F4a_D"};

/***/ }),

/***/ 3115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_actions":"entity-actions_entity_actions___FIaQ","menu_button":"entity-actions_menu_button__8wzDR"};

/***/ }),

/***/ 68404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity":"entity_entity__AWEQ3","content":"entity_content__7lRgo","entityMenu":"entity_entityMenu__m3g7R","footer":"entity_footer__7mvpx","hover":"entity_hover__ZZX8T"};

/***/ }),

/***/ 38244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_field":"entity-field_entity_field__QGeVR","content":"entity-field_content__xjWlB","title":"entity-field_title__nABa2","description":"entity-field_description__a2Fok","label":"entity-field_label__t3sOk","right":"entity-field_right__g1CEA","menu_button":"entity-field_menu_button__99rEj","flex":"entity-field_flex____qwg"};

/***/ }),

/***/ 50170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_content":"fieldset-content_fieldset_content__dddAu"};

/***/ }),

/***/ 98919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_error":"fieldset-error_fieldset_error__3N6pd"};

/***/ }),

/***/ 55290:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"fieldset_fieldset__JO7vs","error":"fieldset_error__lCQ4p","disabled":"fieldset_disabled__PhBDK"};

/***/ }),

/***/ 70148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer_actions":"fieldset-footer-actions_fieldset_footer_actions__JTZ2Z"};

/***/ }),

/***/ 4266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer":"fieldset-footer_fieldset_footer__qgT8K"};

/***/ }),

/***/ 618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer_status":"fieldset-footer-status_fieldset_footer_status__baQ31"};

/***/ }),

/***/ 16549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_header":"fieldset-header_fieldset_header__v_CuI","actions":"fieldset-header_actions__Qwk1H"};

/***/ }),

/***/ 24311:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_subtitle":"fieldset-subtitle_fieldset_subtitle__oWOHM"};

/***/ }),

/***/ 37125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_title":"fieldset-title_fieldset_title__VW1IC"};

/***/ }),

/***/ 37586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table_header":"table-header_table_header__T2fct","header_column":"table-header_header_column__Fk6K2","right":"table-header_right__XR6K4","left":"table-header_left__OHI3u","center":"table-header_center__MwIof"};

/***/ }),

/***/ 97173:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row_item":"table-rows_row_item__Iiq2L","row_active":"table-rows_row_active__Vxkyu","row":"table-rows_row__1abIb","total":"table-rows_total__ioqc0","sub_row":"table-rows_sub_row__inPyz","right":"table-rows_right__mWeCd","left":"table-rows_left__Pdvkm","center":"table-rows_center__rffbm"};

/***/ }),

/***/ 45882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"table_table_wrapper__nmaI7","scroller_overlay_container":"table_scroller_overlay_container__6exFx","scroller_overlay":"table_scroller_overlay__l7mpV","left":"table_left__STZfj","right":"table_right__wuaiM","table_scroller":"table_table_scroller__ibQPr","table_tableWrapper":"table_table_tableWrapper__URTZa","table_empty":"table_table_empty__Y3r8t","table":"table_table__uAH7R","plain":"table_plain___Ieov"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,8367,6657,4321,4894,9774,2888,179], function() { return __webpack_exec__(22764); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);